import { z } from 'zod';
import { $CandidateCurrency } from './CandidateCurrency';

export const $CandidateTariff = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  price: z.number(),
  currency: $CandidateCurrency,
});
